const translations = {
    "nl-be": {
        "massieve vloer": "massieve vloer",
        "3. Kies opties en kaders voor uw selectie": "3. Kies opties en kaders voor uw selectie",
        "Verlengde tunnel": "Verlengde tunnel",
        "massieve wand": "massieve wand",
        "Choose your language": "Kies uw taal",
        "Inloggen": "Inloggen",
        "Contact": "Contact",
        "Product configurator": "Product configurator",
        "Product selectie": "Product selectie",
        "Kaders": "Kaders",
        "Mechanismes": "Mechanismes",
        "Opties en kaders": "Opties en kaders",
        "Resultaat": "Resultaat",
        "Please select a product to continue": "Please select a product to continue",
        "Even geduld... uw zoekopdracht wordt verwerkt": "Even geduld... uw zoekopdracht wordt verwerkt",
        "1. Selecteer welke producten u wil configureren": "1. Selecteer welke producten u wil configureren",
        "Geen zoekresultaten gevonden voor de gekozen filter of zoekwoord": "Geen zoekresultaten gevonden voor de gekozen filter of zoekwoord",
        "Uw selectie": "Uw selectie",
        "Okee, ga verder": "Okee, ga verder",
        "Even geduld... uw filters worden verwerkt": "Even geduld... uw filters worden verwerkt",
        "Even geduld... zoeken naar producten": "Even geduld... zoeken naar producten",
        "2. Kies uw mechanismes": "2. Kies uw mechanismes",
        "Kies hieronder eerst uw gewenste mechanismes. Deze worden toegevoegd aan uw selectie. Klik op": "Kies hieronder eerst uw gewenste mechanismes. Deze worden toegevoegd aan uw selectie. Klik op",
        "Smetlood mechanisme": "Smetlood mechanisme",
        "Varianten voor": "Varianten voor",
        "Opties voor": "Opties voor",
        "Gemotoriseerd mechanisme": "Gemotoriseerd mechanisme",
        "Variant": "Variant",
        "Option": "Option",
        "Total": "Total",
        "Please select a mechanism!": "Please select a mechanism!",
        "Please select a variant!": "Please select a variant!",
        "1. Kies hieronder eerst uw gewenste opties en kaders. Deze worden toegevoegd aan uw selectie. Dit is niet verplicht. Om deze stap over te slaan, klik op de knop \u201cOkee, ga verder\u201d in de rechterkolom": "1. Kies hieronder eerst uw gewenste opties en kaders. Deze worden toegevoegd aan uw selectie. Dit is niet verplicht. Om deze stap over te slaan, klik op de knop \u201cOkee, ga verder\u201d in de rechterkolom",
        "Opties": "Opties",
        "Geen opties gevonden": "Geen opties gevonden",
        "Kaders standaard voorzien": "Kaders standaard voorzien",
        "Kaders opties (gratis)": "Kaders opties (gratis)",
        "Kaders opties mits meer prijs": "Kaders opties mits meer prijs",
        "Geen kaders gevonden": "Geen kaders gevonden",
        "Mechanisme": "Mechanisme",
        "Total configuratie": "Total configuratie",
        "Totaal configuratie": "Totaal configuratie",
        "4. Resultaat van uw configuratie": "4. Resultaat van uw configuratie",
        "Hieronder vindt u de lijst en kostprijs van uw configuratie. Klik op de knop \u201cDownload documenten\u201d om een pakket of selectie te downloaden. Klik op export om uw configuratie als .xls of .pdf document te downloaden.": "Hieronder vindt u de lijst en kostprijs van uw configuratie. Klik op de knop \u201cDownload documenten\u201d om een pakket of selectie te downloaden. Klik op export om uw configuratie als .xls of .pdf document te downloaden.",
        "Download documenten": "Download documenten",
        "Exporteer als Excel": "Exporteer als Excel",
        "Exporteer als Pdf": "Exporteer als Pdf",
        "Alles verwijderen": "Alles verwijderen",
        "Type Klep": "Type Klep",
        "Mechanisme - Opties \u2013 Kaders": "Mechanisme - Opties \u2013 Kaders",
        "Aantal": "Aantal",
        "Eenheidsprijs": "Eenheidsprijs",
        "Totaal": "Totaal",
        "Voeg een nieuwe  configuratie toe": "Voeg een nieuwe  configuratie toe",
        "Nieuwe configuratie": "Nieuwe configuratie",
        "Of baseer die op uw vorige configuratie": "Of baseer die op uw vorige configuratie",
        "Zelfde product": "Zelfde product",
        "Nieuw mechanisme": "Nieuw mechanisme",
        "Nieuw product": "Nieuw product",
        "zelfde mechanisme": "zelfde mechanisme",
        "Nieuwe opties en kaders": "Nieuwe opties en kaders",
        "Bent u zeker dat u deze configuratie wilt verwijderen?": "Bent u zeker dat u deze configuratie wilt verwijderen?",
        "Bent u zeker dat u wilt alles verwijderen?": "Bent u zeker dat u wilt alles verwijderen?",
        "Toon alle info en classificaties": "Toon alle info en classificaties",
        "Aanbevolen": "Aanbevolen",
        "Toon afmetingen": "Toon afmetingen",
        "Verberg afmetingen": "Verberg afmetingen",
        "afmetingen": "afmetingen",
        "Breedte (mm)": "Breedte (mm)",
        "Hoogte (mm)": "Hoogte (mm)",
        "Diameter (mm)": "Diameter (mm)",
        "Rechthoekig": "Rechthoekig",
        "Rond": "Rond",
        "Minimale brandweerstand (in minuten)": "Minimale brandweerstand (in minuten)",
        "brandweerstand": "brandweerstand",
        "Advanced filters": "Advanced filters",
        "Soort wand ": "Soort wand ",
        "Dikte wand": "Dikte wand",
        "Afdichting": "Afdichting",
        "Kies hieronder eerst uw gewenste mechanisme. Deze worden toegevoegd aan uw selectie. ": "Kies hieronder eerst uw gewenste mechanisme. Deze worden toegevoegd aan uw selectie. ",
        "Lichte, flexibele of asymmetrische wand": "Lichte, flexibele of asymmetrische wand",
        "voor meer info.": "voor meer info.",
        "bruto prijs": "bruto prijs",
        "hoeveelheid": "hoeveelheid",
        "Kader": "kader",
        "Optie": "optie",
        "optie MEC": "optie MEC",
        "MEC + opties": "MEC + opties",
        "ERP code": "ERP code",
        "Product": "Product",
        "gedetailleerd overzicht": "gedetailleerd overzicht",
        "language": "Belgi\u00eb",
        "Mortel": "Mortel",
        "Gips": "Gips",
        "Brandwerende plaaster": "Brandwerende plaaster",
        "Zachte steenwol >= 40kg\/m3 + afdekplaten": "Zachte steenwol >= 40kg\/m3 + afdekplaten",
        "Zachte steenwol >= 60kg\/m3": "Zachte steenwol >= 60kg\/m3",
        "Zachte steenwol >= 40kg\/m3 + gips + afdekplaten": "Zachte steenwol >= 40kg\/m3 + gips + afdekplaten",
        "Gecoate (harde) steenwol + coating >= 140kg\/m3": "Gecoate (harde) steenwol + coating >= 140kg\/m3",
        "Gecoate (harde) steenwol + coating >= 140kg\/m3 + coating op tunnel\/kanaal": "Gecoate (harde) steenwol + coating >= 140kg\/m3 + coating op tunnel\/kanaal",
        "Inbouwkit IFW": "Inbouwkit IFW",
        "Geen afdichting nodig": "Geen afdichting nodig",
        "Kleppen van 1s": "Kleppen van 1s",
        "Speciale installaties": "Speciale installaties",
        "OK, kies Mechanismes": "OK, kies Mechanismes",
        "materiaal + dikte": "materiaal + dikte",
        "Brandwerend systeemplafond": "Brandwerend systeemplafond",
    }, "en-gb": {
        "massieve vloer": "rigid floor",
        "3. Kies opties en kaders voor uw selectie": "3. Choose options and mounting frames for your selection",
        "Verlengde tunnel": "Extended tunnel",
        "massieve wand": "rigid wall",
        "Choose your language": "Choose your language",
        "Inloggen": "login",
        "Contact": "Contact",
        "Product configurator": "Product configurator",
        "Product selectie": "Product selection",
        "Kaders": "Frames",
        "Mechanismes": "Mechanisms",
        "Opties en kaders": "Options and mounting frames",
        "Resultaat": "Result",
        "Please select a product to continue": "Please select a product to continue",
        "Even geduld... uw zoekopdracht wordt verwerkt": "Please wait ... your search query is being processed",
        "1. Selecteer welke producten u wil configureren": "1. Select which products you want to configure",
        "Geen zoekresultaten gevonden voor de gekozen filter of zoekwoord": "No results found",
        "Uw selectie": "Your selection",
        "Okee, ga verder": "OK, continue",
        "Even geduld... uw filters worden verwerkt": "Please wait ... your filters are being processed",
        "Even geduld... zoeken naar producten": "Please wait ... search for products",
        "2. Kies uw mechanismes": "2. Choose your mechanisms",
        "Kies hieronder eerst uw gewenste mechanismes. Deze worden toegevoegd aan uw selectie. Klik op": "Choose your preferred mechanism below. These are added to your selection. ",
        "Smetlood mechanisme": "Mechanism with fusible link",
        "Varianten voor": "Variants for",
        "Opties voor": "Options for",
        "Gemotoriseerd mechanisme": "Motorized mechanism",
        "Variant": "Variant",
        "Option": "Option",
        "Total": "Total",
        "Please select a mechanism!": "Please select a mechanism!",
        "Please select a variant!": "Please select a variant!",
        "1. Kies hieronder eerst uw gewenste opties en kaders. Deze worden toegevoegd aan uw selectie. Dit is niet verplicht. Om deze stap over te slaan, klik op de knop \u201cOkee, ga verder\u201d in de rechterkolom": "1. Please select your preferred option and mounting frame. This step is not mandatory. To skip this step, click on the button \"Continue\" in the right-hand column.",
        "Opties": "Options",
        "Geen opties gevonden": "No options found",
        "Kaders standaard voorzien": "Standard frames provided",
        "Kaders opties (gratis)": "Frame options (free)",
        "Kaders opties mits meer prijs": "Frame options (extra charge)",
        "Geen kaders gevonden": "No frames found",
        "Mechanisme": "Mechanism",
        "Total configuratie": "Total configuration",
        "Totaal configuratie": "Total configuration",
        "4. Resultaat van uw configuratie": "4. Result of your configuration",
        "Hieronder vindt u de lijst en kostprijs van uw configuratie. Klik op de knop \u201cDownload documenten\u201d om een pakket of selectie te downloaden. Klik op export om uw configuratie als .xls of .pdf document te downloaden.": "Below you will find a compilation of your configuration. Total cost is included. Click on \"Download documents\" to download your configuration including classification reports. Click on export to download your configuration separately as an .xls or .pdf document.",
        "Download documenten": "Download documents",
        "Exporteer als Excel": "Export as Excel",
        "Exporteer als Pdf": "Export as Pdf",
        "Alles verwijderen": "Delete all",
        "Type Klep": "Damper type",
        "Mechanisme - Opties \u2013 Kaders": "Mechanism - Options - Mounting frames",
        "Aantal": "Number",
        "Eenheidsprijs": "Unit price",
        "Totaal": "Total",
        "Voeg een nieuwe  configuratie toe": "Add a new configuration",
        "Nieuwe configuratie": "New configuration",
        "Of baseer die op uw vorige configuratie": "Based on your previous configuration",
        "Zelfde product": "Same product",
        "Nieuw mechanisme": "New mechanism",
        "Nieuw product": "New product",
        "zelfde mechanisme": "Same mechanism",
        "Nieuwe opties en kaders": "New options and mounting frames",
        "Bent u zeker dat u deze configuratie wilt verwijderen?": "Are you sure you want to remove this configuration?",
        "Bent u zeker dat u wilt alles verwijderen?": "Are you sure you want to delete this configuration?",
        "Toon alle info en classificaties": "Show all info and classifications",
        "Aanbevolen": "Recommended",
        "Toon afmetingen": "Show dimensions",
        "Verberg afmetingen": "Hide dimensions",
        "afmetingen": "dimensions",
        "Breedte (mm)": "Width (mm)",
        "Hoogte (mm)": "Height (mm)",
        "Diameter (mm)": "Diameter (mm)",
        "Rechthoekig": "Rectangular",
        "Rond": "Circular",
        "Minimale brandweerstand (in minuten)": "Minimum fire resistance (in minutes)",
        "brandweerstand": "Fire resistance",
        "Advanced filters": "Advanced filters",
        "Soort wand ": "Wall type",
        "Dikte wand": "Wall thickness",
        "Afdichting": "Sealing",
        "Kies hieronder eerst uw gewenste mechanisme. Deze worden toegevoegd aan uw selectie. ": "Choose your preferred mechanism below. These are added to your selection. ",
        "Lichte, flexibele of asymmetrische wand": "light wall",
        "voor meer info.": "more information.",
        "bruto prijs": "after tax",
        "hoeveelheid": "amount",
        "Kader": "frame",
        "Optie": "option",
        "optie MEC": "option MEC",
        "MEC + opties": "MEC + options",
        "ERP code": "ERP code",
        "Product": "Product",
        "gedetailleerd overzicht": "detailed overview",
        "language": "Europe (english)",
        "Mortel": "Mortar",
        "Gips": "Gypsum",
        "Brandwerende plaaster": "Fire-resistant gypsum",
        "Zachte steenwol >= 40kg\/m3 + afdekplaten": "soft rock wool >= 40kg\/m3 + cover plates",
        "Zachte steenwol >= 60kg\/m3": "soft rock wool >= 60kg\/m3",
        "Zachte steenwol >= 40kg\/m3 + gips + afdekplaten": "soft rock wool >= 40kg\/m3 + gypsum + cover plates",
        "Gecoate (harde) steenwol + coating >= 140kg\/m3": "Coated (rigid) rock wool + coating >= 140kg\/m3",
        "Gecoate (harde) steenwol + coating >= 140kg\/m3 + coating op tunnel\/kanaal": "Coated (rigid) rock wool + coating >= 140kg\/m3 + coating on shaft",
        "Inbouwkit IFW": "Installation kit",
        "Geen afdichting nodig": "Not applicable",
        "Kleppen van 1s": "Surface mounted 1s",
        "Speciale installaties": "Special combinations",
        "OK, kies Mechanismes": "OK, choose Mechanisms",
        "afdichting": "sealing",
        "wandtype": "wall type",
        "OK, kies Opties en kaders": "OK, choose Options and Frames",
        "OK, toon resultaat": "OK, show result",
        "materiaal + dikte": "material + thickness",
        "Brandwerend systeemplafond": "Fire resistant suspended ceiling",
        "lichte, flexibele of asymmetrische wand": "light, flexible or asymmetrical wall",
        "Cellenbeton &ge; 100 mm": "Aerated concrete ≥ 100 mm",
        "Cellenbeton &ge; 150 mm": "Aerated concrete ≥ 150 mm",
        "Cellenbeton &ge; 125 mm": "Aerated concrete ≥ 125 mm",
        "Gewapend beton &ge; 110 mm": "Reinforced concrete ≥ 110 mm ",
        "Gewapend beton &ge; 150 mm": "Reinforced concrete ≥ 150 mm ",
        "Gipsblokken &ge; 70 mm": "Gypsum blocks ≥ 70 mm",
        "Gipsblokken &ge; 100 mm": "Gypsum blocks ≥ 100 mm",
        "Metal stud gipsplaten type F 2 x 12.5 mm": "Metal studs gypsum plasterboard type F 2 x 12.5 mm",
        "Metal stud gipsplaten type F 2 x 15 mm": "Metal studs gypsum plasterboard type F 2 x 15 mm",
        "": "",
    }
}
export default translations


// WEBPACK FOOTER //
// ./src/lang/translations.js